import DOMPurify from 'dompurify'

var ALLOWED_TAGS = [
  'p', 'br', 'div', 'span', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'a',
  'blockquote', 'pre', 'code', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'table', 'thead', 'tbody', 'tr', 'td', 'th', 'img', 'hr'
]

var FORBID_TAGS = ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'link', 'meta', 'base']

var ALLOWED_URI_REGEXP = /^(?:(?:https?|mailto|tel|cid):|data:image\/(?:png|gif|jpe?g|webp|bmp);|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i

var CONFIG = {
  ALLOWED_TAGS: ALLOWED_TAGS,
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'width', 'height', 'style', 'class', 'align', 'colspan', 'rowspan', 'target', 'rel', 'border', 'cellpadding', 'cellspacing'],
  FORBID_TAGS: FORBID_TAGS,
  ALLOWED_URI_REGEXP: ALLOWED_URI_REGEXP
}

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if (node.tagName && node.tagName.toLowerCase() === 'a') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export function sanitizeEmailHtml (html) {
  if (html === null || html === undefined) {
    return ''
  }
  return DOMPurify.sanitize(String(html), CONFIG)
}

export default sanitizeEmailHtml
